<template lang="pug">
section.section
  validation-observer(ref='appointmentForm')
    form(@submit.prevent='onSubmit')
      .booking-step
        .row.d-flex.align-items-start
          .col-md-6
            .booking-step-title
              label
                strong.text-primary 01
                span เลือกบริการที่ต้องการ

          .col-md-6
            .booking-step-field
              validation-provider(
                v-slot='{ errors, valid }',
                rules='required',
                name='บริการ'
              )
                label.form-label.visually-hidden(for='time') เลือกบริการ
                select.form-select.form-select-lg(
                  v-model='form.service',
                  aria-label='เลือกบริการ',
                  @input='onServiceSelect',
                  :class='{ "is-invalid": errors[0], "is-valid": valid }'
                )
                  option(selected, value='') เลือกบริการ
                  option(value='ซ่อมบำรุง ') ซ่อมบำรุง
                  option(value='เปลี่ยนแบต') เปลี่ยนแบต
                  option(value='ฉีดพ่นฆ่าเชื้อ') ฉีดพ่นฆ่าเชื้อ

                .invalid-feedback {{ errors[0] }}

      .booking-step(ref='step2')
        .row.d-flex.align-items-start
          .col-md-6
            .booking-step-title
              label(for='date')
                strong.text-primary 02
                span ระบุวัน-เวลานัดหมาย

          .col-md-6
            .booking-step-field
              .mb-4
                validation-provider(
                  v-slot='{ errors, valid }',
                  rules='required',
                  name='วันนัดหมาย'
                )
                  label.form-label.visually-hidden(for='date') วันนัดหมาย
                  date-picker.w-100(
                    v-model='form.date',
                    input-class='form-control form-control-lg',
                    placeholder='เลือกวันนัดหมาย *',
                    format='DD-MM-YYYY'
                  )
                  //- input#date.form-control.form-control-lg(
                  //-   v-model='form.date',
                  //-   type='date',
                  //-   placeholder='เลือกวันนัดหมาย *',
                  //-   :class='{ "is-invalid": errors[0], "is-valid": valid }'
                  //- )
                  .invalid-feedback {{ errors[0] }}

              validation-provider(
                v-slot='{ errors, valid }',
                rules='required',
                name='เวลานัดหมาย'
              )
                label.form-label.visually-hidden(for='time') เวลานัดหมาย
                select#time.form-select.form-select-lg(
                  v-model='form.time',
                  aria-label='เลือกเวลานัดหมาย',
                  @change='onTimeSelect',
                  :class='{ "is-invalid": errors[0], "is-valid": valid }'
                )
                  option(selected, value='') เลือกเวลานัดหมาย
                  option(value='09:00 น.') 09:00 น.
                  option(value='10:00 น.') 10:00 น.
                  option(value='11:00 น.') 11:00 น.
                  option(value='13:00 น.') 13:00 น.
                  option(value='14:00 น.') 14:00 น.
                  option(value='15:00 น.') 15:00 น.
                  option(value='16:00 น.') 16:00 น.
                .invalid-feedback {{ errors[0] }}

      .booking-step(ref='step3')
        .row.d-flex.align-items-start
          .col-md-6
            .booking-step-title
              label(for='name')
                strong.text-primary 03
                span ระบุข้อมูลของท่าน
          .col-md-6
            .booking-step-field
              .mb-4
                validation-provider(
                  v-slot='{ errors, valid }',
                  rules='required',
                  name='ชื่อ'
                )
                  label.form-label.visually-hidden(for='firstname') ชื่อ
                  input#firstname.form-control.form-control-lg(
                    v-model='form.firstname',
                    type='text',
                    placeholder='ชื่อ *',
                    :class='{ "is-invalid": errors[0], "is-valid": valid }'
                  )
                  .invalid-feedback {{ errors[0] }}

              .mb-4
                label.form-label.visually-hidden(for='lastname') นามสกุล
                input#lastname.form-control.form-control-lg(
                  v-model='form.lastname',
                  type='text',
                  placeholder='นามสกุล '
                )
              .mb-4
                validation-provider(
                  v-slot='{ errors, valid }',
                  rules='required|numeric',
                  name='เบอร์โทรศัพท์'
                )
                  label.form-label.visually-hidden(for='mobile') เบอร์โทรศัพท์
                  input#mobile.form-control.form-control-lg(
                    v-model='form.mobile',
                    type='tel',
                    placeholder='เบอร์โทรศัพท์ *',
                    :class='{ "is-invalid": errors[0], "is-valid": valid }'
                  )
                  .invalid-feedback {{ errors[0] }}
              .mb-4
                label.form-label.visually-hidden(for='email') อีเมล
                input#email.form-control.form-control-lg(
                  v-model='form.email',
                  type='email',
                  placeholder='อีเมล (ถ้ามี)'
                )

              .mb-4
                .form-check.form-check-inline
                  validation-provider(
                    v-slot='{ errors, valid }',
                    rules='required',
                    name='ยอมรับ'
                  )
                    input#inlineCheckbox1.form-check-input(
                      type='checkbox',
                      v-model='form.accept',
                      false-value='',
                      :class='{ "is-invalid": errors[0] }'
                    )
                    label.form-check-label(for='inlineCheckbox1')
                      span ฉันได้อ่านและยอมรับ
                      a(
                        href='https://ugocorp.com/privacy-policy/',
                        target='_blank'
                      ) นโยบายความเป็นส่วนตัว
                    .invalid-feedback {{ errors[0] }}
              button.button(type='submit', :disabled='!form.accept') นัดหมาย

  #alert.modal.fade(
    tabindex='-1',
    aria-labelledby='alertLabel',
    aria-hidden='true'
  )
    .modal-dialog.modal-sm.modal-dialog-centered
      .modal-content
        .modal-header.justify-content-center
          h4#alertLabel.modal-title ส่งข้อมูลสำเร็จ
        .modal-body.pt-4
          checkark
          p.pt-3.text-center ได้รับข้อมูลการจองของท่านแล้ว ...ทางทีมงานจะรีบติดต่อกลับไปครับ

        .modal-footer.justify-content-center
          button.button(type='button', data-bs-dismiss='modal') Ok
</template>

<script>
// import MoveTo from 'moveto'
import DatePicker from 'vue2-datepicker'
import axios from 'axios'
import Modal from 'bootstrap/js/src/modal.js'
import Checkark from '../components/Checkmark'

export default {
  components: { Checkark, DatePicker },
  data: () => ({
    buttonLoading: false,
    form: {},
  }),

  created() {
    this.resetForm()
  },

  methods: {
    resetForm() {
      this.form = {
        service: '',
        date: null,
        time: '',
        name: '',
        surname: '',
        accept: '',
      }
    },
    onSubmit() {
      this.buttonLoading = true
      const form = this.$refs.appointmentForm
      form.validate().then((success) => {
        if (!success) {
          setTimeout(() => {
            const errors = Object.entries(form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter((error) => error['value'].length)

            const to = form.refs[errors[0]['key']].$el
            to.closest('.booking-step').scrollIntoView()
            this.buttonLoading = false
          }, 100)
          return
        } else {
          axios
            .post(`${UGO.api.url}v1/appointment`, this.form)
            .then(({ status }) => {
              if (status) {
                const myModal = new Modal(document.getElementById('alert'))
                myModal.show()
                requestAnimationFrame(() => {
                  this.resetForm()
                  form.reset()
                })
              }
            })
            .catch((error) => {
              console.log(error)
            })
            .then(() => {
              this.buttonLoading = false
            })
        }
      })
    },

    onServiceSelect() {
      setTimeout(() => {
        this.$refs.step2.scrollIntoView()
      }, 400)
    },

    onTimeSelect() {
      console.log(this.form.date)
      console.log(this.form.time)
      if (this.form.date && this.form.time) {
        setTimeout(() => {
          this.$refs.step3.scrollIntoView()
        }, 400)
      }
    },
  },
}
</script>